///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class SelectLanguageScreen extends BaseScreen {

        public static LANGUAGUES:object = {
            "DE":'Deutsch',
            "EN":'English',
            "ES":'Español',
            "JA":'日本語',
            "NL":'Nederland',
            "SK":'Slovenčina'
        };

        buttons:object;
        hi_mc:Phaser.GameObjects.Image;
        chick_mc:Phaser.GameObjects.Sprite;

        private prevLabel;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_selectLanguageBG_'+'0000').setOrigin(0, 0));

            this.buttons = {};
            let i:number = 0;
            for (let lang in SelectLanguageScreen.LANGUAGUES) {
                let btn:Phaser.GameObjects.Container = new Phaser.GameObjects.Container(this.scene, 125, 60 + i * 39);
                let label:Phaser.GameObjects.Text = this.scene.add.text(-50, -10, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 18,
                    "color": "#5495A4",
                    "align": 'left'
                });
                btn.add(label);
                btn['label'] = label;
                nscs.util.Functions.updateTextFieldPosition(label, SelectLanguageScreen.LANGUAGUES[lang]);
                this.add(btn);
                btn.setSize(190, 37);
                btn.setInteractive({cursor: 'pointer'});
                btn.on('pointerup', () => {
                    nscs.gameplay.Gameplay.currentLanguage = lang;

                    nscs.scene.MainScene.instance.switchScreen(new MainMenuScreen(this.scene));

                    let gaEventLabelMap:object = {
                        "DE":'New Super Chick Sisters - Language German',
                        "EN":'New Super Chick Sisters - Language English',
                        "ES":'New Super Chick Sisters - Language Spanish',
                        "JA":'New Super Chick Sisters - Language Japanese',
                        "NL":'New Super Chick Sisters - Language Dutch',
                        "SK":'New Super Chick Sisters - Language Slovak'
                    };
                    sendEvent(petaGA_GameCategory_Game, 'Language Selection', gaEventLabelMap[lang]);
                });
                btn.on('pointerout', () => {
                });
                btn.on('pointerover', () => {
                    this.prevLabel.setColor("#5495A4");
                    this.prevLabel = label;

                    label.setColor("#FFFFFF");
                    this.hi_mc.setFrame(this.hi_mc["framesMap"][lang]);

                    this.scene.tweens.add({
                        targets: this.chick_mc,
                        y: btn.y,
                        duration: 650,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                });
                this.buttons[lang] = btn;
                i++;
            }

            this.hi_mc = new Phaser.GameObjects.Image(this.scene, 315, 80, 'ui-atlas', 'hi_mc' + '0000');
            this.hi_mc["framesMap"] = {
                "EN":'hi_mc' + '0000',
                "NL":'hi_mc' + '0004',
                "ES":'hi_mc' + '0009',
                "SK":'hi_mc' + '0014',
                "JA":'hi_mc' + '0019',
                "DE":'hi_mc' + '0024'
            };
            this.add(this.hi_mc);

            this.chick_mc = nscs.scene.MainScene.instance.factory.createConstructedObject("tinyChickMC") as Phaser.GameObjects.Sprite;
            this.chick_mc.setOrigin(0.5, 0.5);
            this.add(this.chick_mc);

            //def english
            this.prevLabel = this.buttons[nscs.gameplay.Gameplay.currentLanguage]['label'];
            this.prevLabel.setColor("#FFFFFF");
            requestAnimationFrame(()=>{this.chick_mc.setPosition(50, this.buttons[nscs.gameplay.Gameplay.currentLanguage].y);});
        }
    }
}